const token = "6a029180545a76ad6aff28ef930a6546f9ec647ae669a43692bd7cb55a15d8d1";
const myUrl = 'https://payments.napoleon-chat.com/#/'
const serverSrc = 'https://prd-nn.napoleon-chat.com/api/';
const serverPayU = 'https://checkout.payulatam.com/ppp-web-gateway-payu/'
const merchant = '984952'
const account = '993047'
// const myUrl = 'https://test-payment.napoleon-chat.com/#/'
// const serverSrc = 'https://staging.napoleon-chat.com/api/';
// const serverPayU = 'https://sandbox.checkout.payulatam.com/ppp-web-gateway-payu/'
// const merchant = '508029'
// const account = '512321'

export default
  {
    serverSrc, // dirección del servidor
    serverPayU,
    merchant,
    account,
    token,
    myUrl
  }